var map = {
	"./feature_buy_en.png": 97157,
	"./feature_buy_id.png": 86859,
	"./feature_buy_ph.png": 86340,
	"./feature_buy_th.png": 46808,
	"./feature_buy_zh.png": 12006
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49991;